import React from 'react';
import { ScrollToTopSection } from './contact/ScrollToTopSection';
import { EyebrowSection } from './contact/EyebrowSection';
import { HeaderSection } from './contact/HeaderSection';
import { HeroSection } from './contact/HeroSection';
import { ContactInfoSection } from './contact/ContactInfoSection';
import { ContactFormSection } from './contact/ContactFormSection';
import { FooterSection } from './contact/FooterSection';
export function ContactPage() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-296">
      <ScrollToTopSection data-id="element-297" />
      <EyebrowSection data-id="element-298" />
      <HeaderSection data-id="element-299" />
      <main className="flex-grow" data-id="element-300">
        <HeroSection data-id="element-301" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-302">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-303">
            <ContactInfoSection data-id="element-304" />
            <ContactFormSection data-id="element-305" />
          </div>
        </div>
      </main>
      <FooterSection data-id="element-306" />
    </div>;
}